{
  "service-selection-dialog": {
    "buttons": {
      "save": "Lưu"
    },
    "text": {
      "service-selection": "Lựa chọn dịch vụ"
    }
  },
  "service-selection-form": {
    "buttons": {
      "add-more": "Thêm dịch vụ"
    },
    "text": {
      "duration": "Thời lượng",
      "hint": "Vui lòng chọn ít nhất một dịch vụ",
      "total": "Tổng cộng"
    }
  }
}
